'use client'
import './polyfills'

export const PolyfillContext = ({ children }: PropsWithChildren) => {
  return children
}
